import React from "react";
import queryString from "query-string";
import {toast} from "react-toastify";
import {Helpers} from "../../../config/Helpers";
import {ReactSession} from "react-client-session";
import {decode as base64_decode, encode as base64_encode} from "base-64";

class Pulsa extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            operatorData : [],
            produkData : [],
            operator:'',
            selectedProduk:'',
            nomor:'',
            noDataDisplay: false
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getOperator();
        }
    }

    getOperator = () => {
        Helpers.GetListMaxtopOperator().then(res => {
            this.setState({
                operatorData: res
            });
        })
    };

    getProduk = (state,value) =>{
        this.setState({
            [state]: value
        }, () => {
            let kode = this.state.operatorData.find(obj => obj.id === parseInt(this.state[state])).kode;
            Helpers.GetListMaxtopProdukPreset('Pulsa', kode).then(res => {
                this.setState({
                    produkData: res,
                    noDataDisplay: true
                });
            })
        });
    }

    selectProduk = (state, value) =>{
        this.setState({
            [state] : value.kode
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const {nomor, selectedProduk} = this.state;
        let valid = true;
        let errorMessage = '';

        if(!nomor || nomor.trim() === ''){
            errorMessage= 'Nomor Handphone tidak boleh kosong';
            valid = false;
        }else if(nomor.trim().length < 11){
            errorMessage ='Nomor Handphone minimal 11 digit';
            valid = false
        }

        if(!selectedProduk){
            errorMessage = 'Nominal harus dipilih';
            valid = false
        }

        if(!valid){
            alert(errorMessage);
        }else{

            const provider = this.state.operatorData.find(
                item => item.id === parseInt(this.state.operator)
            );

            const produk = this.state.produkData.find(
                item => item.kode === this.state.selectedProduk
            );

            ReactSession.set("ppob_nomor", this.state.nomor);
            ReactSession.set("ppob_provider", provider ? provider.nama : "");
            ReactSession.set("ppob_produk", produk ? produk.nama : "");
            ReactSession.set("ppob_kode", produk ? produk.kode : "");
            ReactSession.set("ppob_price", produk ? produk.harga_fix : "");
            ReactSession.set("ppob_type", "PULSA");

            window.location.href = './ppob-payment?urlback=' + base64_encode(window.location.href);
        }
    };

    render() {
        return (
            <>
                <main className="main pages mb-80">
                    <div className="page-content pt-10">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 m-auto">
                                    <div className="card">
                                        <div className="card-body contact-from-area background-ppob">
                                            <form className="contact-form-style mt-30 mb-30"
                                                  method="post" onSubmit={(e) => {this.handleSubmit(e)}}>

                                                <div className="input-style mb-20">
                                                    <label>Nomor Handphone</label>
                                                    <div className="row">
                                                        <div className="col-12 white">
                                                            <input value={this.state.nomor} onChange={e => this.setState({nomor: e.target.value})}
                                                                   placeholder="Contoh: 08xxxxxxxxxx"
                                                                   type={'number'} required/>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="input-style mb-20">
                                                    <label>Provider</label>
                                                    <div className="custom_select white ">
                                                        <select
                                                            className="select-style" required onChange={e => this.getProduk('operator', e.target.value)}>
                                                            <option value={''}>Pilih Provider</option>
                                                            {
                                                                this.state.operatorData.map((object, i) => {
                                                                    return <option value={object.id} selected={(this.state.operator == object.id) ? 'selected' : ''}>{object.nama}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="input-style mb-20">
                                                    <button type="submit"
                                                            className="btn btn-heading btn-block hover-up"
                                                            name="bayar">Lanjut Bayar
                                                    </button>
                                                </div>

                                                <div className="grid-ppob-pulsa" style={{"margin-top": "35px"}}>
                                                    {
                                                        this.state.produkData.map((item, index) => (
                                                            <div
                                                                key={index}
                                                                className={
                                                                    "container-grid-ppob-pulsa " + ((item.kode === this.state.selectedProduk) ? 'ppob-selected' : '')
                                                                }
                                                                onClick={() => this.selectProduk('selectedProduk', item)}
                                                            >
                                                                <div className="text-grid-ppob">
                                                                    <div className="fw-bold">{item.nama}</div>
                                                                    <div>Rp {Number(item.harga_fix).toLocaleString("id-ID")}</div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }

                                                </div>
                                                {
                                                    (this.state.produkData.length === 0 && this.state.noDataDisplay) && (
                                                        <div className={'tengah '} ><img src={'./assets/imgs/icon/nodata.png'}/></div>
                                                    )
                                                }
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default Pulsa;